<template>
  <Walkthrough 
    roomName="The Office"
    roomKey="office"
    :steps="steps"
    :backgroundImage="backgroundImage"
  />
</template>
<script>

export default {
  name: 'Office',
  props: ["roomName"],
  data() {
    return {
      backgroundImage: "https://d37bvzh6941o03.cloudfront.net/EscapeTheRoom/images/backgrounds/office-1920x1280.jpg",
      steps: [
        "Look left, and then look at the desk. ",
        "Now that you know there is a letter on the desk, look at the letter. ",
        "The letter contains clues for the circuit breaker. Notice the four objects in the room mentioned in the letter, and the order that they appear in. Then look at those items in the room and identify their colors. ",
        "Now that you know the four colors, look right, and inspect the circuit breaker. You can now enter the colors green, red, blue, white and power should begin to flow in the room. This will come in handy later. ",
        "Now look down and inspect the trap door. You should find a crowbar inside. ",
        "Now that you have the crowbar, look left at the desk and then use the crowbar on the drawer. You should find a screwdriver. ",
        "Now that you have the screwdriver, you can look up and use the screwdriver on the vent. Inside you should find a hammer. ",
        "With the hammer that you have now, you can look left and the use the hammer to break the thick glass frame around the photo. This should reveal a message on the back. ",
        "Using the message you found on the back of the photo, you shuold be able to take the daughters age (5 years old), and the date of the photo (1995) to use as the passcode for the safe, 0390 (The daughter's birth day, March 1990) ",
        "Now look to the right and inspect the safe. You should enter the code 0390 into the safe and find the final key! ",
        "Using the key you can now look forward, use the key on the door, and escape to freedom. Congratulations you've escaped. Try solving the next room on your own! ",
      ]
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/walkthrough/office.vue